import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Image } from './Image'

export const SortableImages = (props: {
    id: string
    url: string
    index: number
    activeId: string
}) => {
    const { id, url, index, activeId } = props
    const sortable = useSortable({ id: id })
    const { attributes, listeners, setNodeRef, transform, transition } = sortable

    return (
        <Image
            ref={setNodeRef}
            key={id}
            index={index}
            url={url}
            activeId={activeId}
            {...attributes}
            {...listeners}
            style={{
                transform: CSS.Transform.toString(transform),
                transition,
            }}
        />
    )
}
